import { CartLinesUpdateEvent } from '@shopify/events';

const tl = (kurus) => {
  const n = Math.round(Number(kurus) / 100);
  return `${n.toLocaleString('tr-TR')} ₺`;
};

function isGunuEkle(gun) {
  const d = new Date();
  let kalan = gun;
  while (kalan > 0) {
    d.setDate(d.getDate() + 1);
    const g = d.getDay();
    if (g !== 0 && g !== 6) kalan -= 1;
  }
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'long' });
}

class EssentalUrun {
  constructor(kok) {
    this.kok = kok;
    this.form = kok.querySelector('[data-es-form]');
    this.paketler = [...kok.querySelectorAll('[data-paket]')];
    this.esik = Number(kok.dataset.esik || 0);
    this.kargo = Number(kok.dataset.kargo || 0);
    this.$ = (s) => kok.querySelector(s);
    const t = this.$('[data-kargo-tarih]');
    if (t) t.textContent = `en geç ${isGunuEkle(Number(kok.dataset.gun || 3))}`;
    this.paketler.forEach((el) => {
      const r = el.querySelector('input[type=radio]');
      r.addEventListener('change', () => this.sec(el));
      el.addEventListener('click', () => { r.checked = true; this.sec(el); });
    });
    const ilk = this.paketler.find((el) => el.querySelector('input').checked) || this.paketler[0];
    if (ilk) this.sec(ilk);
    if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.sepete(); });
    this.galeri();
    this.sabit();
  }

  sec(el) {
    this.secili = el;
    this.paketler.forEach((p) => {
      const on = p === el;
      p.classList.toggle('is-on', on);
      p.querySelector('input').checked = on;
    });
    const fiyat = Number(el.dataset.fiyat);
    const adet = Number(el.dataset.adet);
    const ucretsiz = fiyat >= this.esik;
    const toplam = ucretsiz ? fiyat : fiyat + this.kargo;
    const ok = this.$('[data-ozet-kargo]');
    if (ok) ok.textContent = ucretsiz ? `${el.dataset.ad} · kargo ücretsiz` : `${el.dataset.ad} + ${tl(this.kargo)} kargo`;
    const ot = this.$('[data-ozet-toplam]');
    if (ot) ot.textContent = tl(toplam);
    const sf = this.$('[data-sabit-fiyat]');
    if (sf) sf.textContent = tl(fiyat);
    const sa = this.$('[data-sabit-ad]');
    if (sa) sa.textContent = el.dataset.ad;
    this.kok.querySelectorAll('[data-hediye-kart]').forEach((h) => h.classList.toggle('is-acik', adet >= Number(h.dataset.min)));
    const vid = this.$('[data-varyant-id]');
    if (vid && vid.value !== el.dataset.varyant) {
      vid.value = el.dataset.varyant;
      vid.dispatchEvent(new Event('change', { bubbles: true }));
      vid.dispatchEvent(new Event('input', { bubbles: true }));
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', el.dataset.varyant);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) { /* adres güncellenemezse sorun değil */ }
    }
    const po = this.$('[data-paket-ozellik]');
    if (po) po.value = el.dataset.ad;
    const ho = this.$('[data-hediye-ozellik]');
    if (ho) { ho.value = el.dataset.hediye || ''; ho.disabled = !el.dataset.hediye; }
  }

  async sepete() {
    const btn = this.$('[data-sepete]');
    const hata = this.$('[data-hata]');
    hata.hidden = true;
    const el = this.secili;
    if (!el) return;
    const properties = { _paket: el.dataset.ad };
    if (el.dataset.hediye) properties.Hediye = el.dataset.hediye;
    const items = [{ id: Number(el.dataset.varyant), quantity: 1, properties }];
    const bolumler = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
    btn.disabled = true;
    const kok = window.Shopify?.routes?.root || '/';
    const ertelenen = CartLinesUpdateEvent.createPromise();
    this.kok.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(el.dataset.varyant), quantity: 1 }], promise: ertelenen.promise }));
    try {
      const yanit = await fetch(`${kok}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: bolumler.join(',') }),
      }).then((r) => r.json());
      const sepet = await fetch(`${kok}cart.js`).then((r) => r.json());
      const detail = { items: sepet.items, source: 'essental-paket', sourceId: this.kok.id, itemCount: 1, productId: String(this.kok.dataset.urun), sections: yanit.sections, didError: Boolean(yanit.status) };
      ertelenen.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet), detail });
      if (yanit.status) { hata.textContent = yanit.description || yanit.message || 'Sepete eklenemedi, tekrar dene.'; hata.hidden = false; return; }
      if (!document.querySelector('cart-drawer-component')) window.location.href = `${kok}cart`;
    } catch (e) {
      ertelenen.reject(e);
      hata.textContent = 'Bağlantı sorunu oldu, tekrar dene.';
      hata.hidden = false;
    } finally {
      btn.disabled = false;
    }
  }

  galeri() {
    const ana = this.$('[data-galeri-ana]');
    if (!ana) return;
    const kareler = [...ana.children];
    const kucukler = [...this.kok.querySelectorAll('[data-kucuk]')];
    let aktif = 0;
    const isaretle = (i) => { aktif = i; kucukler.forEach((k, j) => k.classList.toggle('is-on', j === i)); };
    const git = (i) => {
      const n = (i + kareler.length) % kareler.length;
      ana.scrollTo({ left: kareler[n].offsetLeft - ana.offsetLeft, behavior: 'smooth' });
      isaretle(n);
    };
    ana.addEventListener('scroll', () => isaretle(Math.round(ana.scrollLeft / ana.clientWidth)), { passive: true });
    kucukler.forEach((k, i) => k.addEventListener('click', () => git(i)));
    this.kok.querySelectorAll('[data-ok]').forEach((b) => b.addEventListener('click', () => git(aktif + Number(b.dataset.ok))));
  }

  sabit() {
    const bar = this.$('[data-sabit]');
    const hedef = this.$('[data-sepete]');
    if (!bar || !hedef || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([g]) => {
      const goster = !g.isIntersecting && g.boundingClientRect.top < 0;
      bar.classList.toggle('is-gorunur', goster);
      bar.setAttribute('aria-hidden', goster ? 'false' : 'true');
      bar.querySelector('[data-sabit-btn]').tabIndex = goster ? 0 : -1;
    });
    io.observe(hedef);
    bar.querySelector('[data-sabit-btn]').addEventListener('click', () => {
      this.$('.es-paketler').scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
}

const baslat = () => document.querySelectorAll('[data-es-urun]').forEach((k) => {
  if (k.dataset.esHazir) return;
  k.dataset.esHazir = '1';
  new EssentalUrun(k);
});
baslat();
document.addEventListener('shopify:section:load', baslat);

// EasySell "Kapıda ödeme" popup'ı açılırken ürünü Shopify sepetine ekliyor; paket değiştirip tekrar açınca eski paket de
// forma giriyordu (1.598 / 3.097 TL). Popup açılmadan önce bu ürünün sepetteki satırları temizlenir → form yalnız seçili paketi gösterir.
window.addEventListener('click', async (e) => {
  const buton = e.target instanceof Element ? e.target.closest('#es-popup-button') : null;
  if (!buton || buton.dataset.esGecis) return;
  const kok = document.querySelector('[data-es-urun]');
  if (!kok) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  try {
    const kokYol = window.Shopify?.routes?.root || '/';
    const sepet = await fetch(`${kokYol}cart.js`).then((r) => r.json());
    const urunId = Number(kok.dataset.urun);
    const updates = {};
    for (const satir of sepet.items || []) if (satir.product_id === urunId) updates[satir.key] = 0;
    if (Object.keys(updates).length) {
      await fetch(`${kokYol}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    }
  } catch (hata) { /* temizlenemezse EasySell yine açılır */ }
  buton.dataset.esGecis = '1';
  buton.click();
  delete buton.dataset.esGecis;
}, true);
